import asyncSweetScroll from '@/helpers/sweet_scroll';
import { applyStoragesMapFilters } from '@/articles/v4/storages_map';

let swipers = [];

$(document).on('turbolinks:before-cache', () => {
  swipers.forEach(swiper => swiper.destroy());
  swipers = [];
});

pageLoad('pages_promo', async () => {
  const article = document.querySelector('article.v4.slide_5');

  const [{ default: Swiper }, { Navigation, Pagination }] = await Promise.all([
    import('swiper'),
    import('swiper/modules')
  ]);

  swipers.push(
    initSizesSwiper(article, { Swiper })
  );

  article
    .querySelectorAll('.swiper[data-type="photos"]')
    .forEach(node => {
      initPhotosSwiper(node, { Swiper, Navigation, Pagination });
      initPhotosGallery(node);
    });

  $('article.v4.slide_5 .to-map').on('click', ({ currentTarget }) => {
    const size = currentTarget.getAttribute('data-size');
    applyStoragesMapFilters({ sizes: size });
    asyncSweetScroll('article.v4.storages_map');
  });

  $('article.v4.slide_5 .is-see_all_photos .photo-tag').on(
    'click',
    ({ currentTarget }) => {
      $(currentTarget).closest('.slide[data-type="sizes"]').find('a.photo').first().click();
    });
});

function initSizesSwiper(article, { Swiper }) {
  const buttons = article.querySelectorAll('header button.size-button');
  const initialIndex = [...buttons].findIndex(node => node.classList.contains('is-active'));
  const node = article.querySelector('.swiper[data-type="sizes"]');

  const swiper = new Swiper(node, {
    wrapperClass: 'slides[data-type="sizes"]',
    slideClass: 'slide[data-type="sizes"]',
    slidesPerView: 1,
    spaceBetween: 32,
    breakpoints: { 1024: { spaceBetween: 64 } },
    allowTouchMove: true,
    initialSlide: initialIndex > 0 ? initialIndex : 0,
    on: {
      slideChange: slide => {
        buttons.forEach((node, i) => (
          node.classList.toggle('is-active', i === slide.activeIndex)
        ));
      }
    }
  });
  swiper.changeLanguageDirection(document.documentElement.getAttribute('dir'));
  buttons.forEach((node, i) => {
    node.addEventListener('click', () => swiper.slideTo(i));
  });

  return swiper;
}

function initPhotosSwiper(node, { Swiper, Navigation, Pagination }) {
  const swiper = new Swiper(node, {
    modules: [Navigation, Pagination],
    wrapperClass: 'slides[data-type="photos"]',
    slideClass: 'slide[data-type="photos"]',
    slidesPerView: 1,
    spaceBetween: 24,
    breakpoints: { 1024: { spaceBetween: 32 } },
    allowTouchMove: true,
    navigation: {
      nextEl: '.b-slider-navigation-v4 .next',
      prevEl: '.b-slider-navigation-v4 .prev',
      disabledClass: 'is-disabled'
    },
    pagination: {
      el: '.b-slider-pagination-v4',
      bulletClass: 'bullet',
      bulletActiveClass: 'is-active',
      clickable: true
    }
  });
  swiper.changeLanguageDirection(document.documentElement.getAttribute('dir'));

  node.addEventListener('pointerdown', e => e.stopPropagation());

  return swiper;
}

function initPhotosGallery(node) {
  $('a.photo', node).magnificPopup({
    type: 'image',
    closeOnContentClick: true,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1]
    }
  });
}
